import React from 'react';

interface Service {
  id: number;
  title: string;
  description: string;
  appLink: string;
  image: string;
  icon: string;
}

interface ServiceCardProps {
  service: Service;
  onServiceClick?: () => void;
  disabled?: boolean; // リンク無効化オプションを追加
}

/**
 * サービスカードコンポーネント
 * 各サービスを表示し、カード全体をクリック可能にしてサービスへ遷移
 * AdminDashboardPageと同じホバーアニメーション
 */
const ServiceCard: React.FC<ServiceCardProps> = ({ service, onServiceClick, disabled = false }) => {
  // カードクリック時の処理
  const handleCardClick = () => {
    if (disabled) return; // 無効化されている場合は何もしない
    
    if (onServiceClick) {
      onServiceClick();
    } else {
      window.location.href = service.appLink;
    }
  };

  return (
    <div className="col-md-4 mb-4">
      <div 
        className="card h-100 shadow-sm border-0 overflow-hidden"
        onClick={handleCardClick}
        style={{ 
          cursor: disabled ? 'default' : 'pointer',
          transition: 'all 0.3s ease',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
        }}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.3)';
          }
        }}
        onMouseLeave={(e) => {
          if (!disabled) {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.25)';
          }
        }}
      >
        {/* サービス画像 */}
        <div className="position-relative" style={{ height: '200px' }}>
          <img 
            src={service.image} 
            className="card-img-top w-100 h-100 object-fit-cover" 
            alt={service.title}
          />
          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
               style={{ 
                 background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2))',
                 opacity: 0,
                 transition: 'opacity 0.3s ease'
               }}
               onMouseEnter={(e) => (e.target as HTMLElement).style.opacity = '1'}
               onMouseLeave={(e) => (e.target as HTMLElement).style.opacity = '0'}>
            <div className="text-white fs-1">
              <i className={service.icon}></i>
            </div>
          </div>
        </div>
        
        {/* カード本体 */}
        <div className="card-body d-flex flex-column p-4">
          <h5 className="card-title zen-old-mincho-bold text-dark mb-3" style={{ fontSize: '1.4rem', lineHeight: '1.3' }}>
            {service.title}
          </h5>
          <p className="card-text zen-old-mincho-regular text-muted flex-grow-1" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            {service.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard; 